
const MOVE_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="{0}" height="{1}" fill="{2}">
<path d="M10 0l4 4h-3v5h5V6l4 4-4 4v-3h-5v5h3l-4 4-4-4h3v-5H4v3l-4-4 4-4v3h5V4H6l4-4z"/>
</svg>
`

export {
    MOVE_ICON
}
